// I need a method that will take the user latitude and longitude and userPreferences object
// and replace the latitude and longitude in the userPreferences object with the user's current location
// and then call the userPreferences thunk with this new updated user preferences

import { UserLocation, UserPreferences } from "../../interfaces/UserObject";
import { updateUserPreferences } from "../thunks/ProfileThunk";
import { AppDispatch } from "../../dataManagement/uiDb/UiDb";


const UserPreferencesUtility = {    
    updateUserLocation : (userPreferences: UserPreferences, userLocation: UserLocation | null, dispatch: AppDispatch) => {
        if(userLocation){
            const updatedUserPreferences = { ...userPreferences, userLocation };
            dispatch(updateUserPreferences(updatedUserPreferences));
        }
    
    },

    updateLocalFindsPreferences : (userPreferences: UserPreferences, localFindsPreferences: {sortPreference: "NEAREST" | "RECENT" | string, ninefindsRadius: number}, dispatch: AppDispatch) => {
        const updatedUserPreferences = { ...userPreferences, ninefindsRadius: localFindsPreferences.ninefindsRadius, searchSortBy: localFindsPreferences.sortPreference };
        dispatch(updateUserPreferences(updatedUserPreferences));
    },

    updateSearchPreferences : (userPreferences: UserPreferences, searchPreferences: {searchSortBy: "NEAREST" | "RECENT" | string, hyperLocalDistance: number, isHyperLocalEnabled: boolean}, dispatch: AppDispatch) => {
        const updatedUserPreferences = { ...userPreferences, hyperLocalDistance: searchPreferences.hyperLocalDistance, searchSortBy: searchPreferences.searchSortBy, isHyperLocalEnabled: searchPreferences.isHyperLocalEnabled };
        dispatch(updateUserPreferences(updatedUserPreferences));
    }
}

export default UserPreferencesUtility;



